import * as React from "react";
import styled, { css } from "styled-components";
import { Button, ButtonGroup } from "components/bootstrap";
import { Icon } from "components/common";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
const StyledButtonToolbar = styled(ButtonGroup)(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.sm};
    display: flex;
    justify-content: space-between;
  `
);
const StepNavigation = ({ onClickNext = void 0, nextButtonText = void 0, setStep }) => {
  const sendTelemetry = useSendTelemetry();
  const onClickPrev = () => {
    setStep("overview");
    sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.THREAT_COVERAGE.IMPROVE_COVERAGE_STEP_BACK, {
      app_pathname: "security",
      app_section: "threat-coverage"
    });
  };
  return /* @__PURE__ */ React.createElement(StyledButtonToolbar, null, /* @__PURE__ */ React.createElement(Button, { onClick: onClickPrev }, /* @__PURE__ */ React.createElement(Icon, { name: "arrow_left_alt", size: "sm" }), " Back to overview"), typeof onClickNext === "function" && /* @__PURE__ */ React.createElement(Button, { onClick: onClickNext }, nextButtonText != null ? nextButtonText : "Next"));
};
export default StepNavigation;
